// extracted by mini-css-extract-plugin
export default {"Container":"CandidateSummaryCardList_Container__OA748","NoData":"CandidateSummaryCardList_NoData__0Oh5y","NoDataText":"CandidateSummaryCardList_NoDataText__VVcmZ"};